module.exports = " <div class=\"header-title flex\"> </div>";


//////////////////
// WEBPACK FOOTER
// ./app/components/calendar/calendar.main/calendar.subcomponent/calendar.table.header/calendar.table.header.html
// module id = 4933
// module chunks = 50